@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/mixins';

.schemaExplorerWrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: $shadow-default;
  border-radius: $border-radius-md;
  border: 1px solid $divider-color;
  background: $surface-bg;
  height: 100%;
}

.sourceDetailsContainer {
  display: flex;
  padding: $spacer * 0.75;
  align-items: center;
  border-bottom: solid $border-width $divider-color;
  flex-shrink: 0;
}

.sourceDetails {
  flex: 1;
  min-width: 0;
}

.sourceRefreshTs {
  align-items: center;
  display: flex;
  max-height: $spacer * 1.125;
}

.schemaSearchContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 $spacer * 1.25;
  min-height: 50px;
  border-bottom: solid $border-width $divider-color;
  background-color: $secondary-bg;
  flex-shrink: 0;

  &.searchAreaNoBorder {
    padding: $spacer * 0.125;
    background-color: $surface-bg;
  }
}

.schemaTreeNoResults {
  padding: $spacer * 0.75 $spacer * 1.25;
  flex-shrink: 0;
}

.listWrapper {
  display: block;
  overflow: auto;
  height: 100%;
  flex: 1;
  overflow-y: auto;
}

.pageError {
  margin-top: $spacer * 5;
  margin-left: $spacer * 1.25;
  margin-right: $spacer * 1.25;
}

.schemaExplorerShimmer {
  height: 100%;
}

.hideLabel {
  display: none;
}
